import { useState } from "react";
import { Link } from "wouter";
import { useAuth } from "../context/AuthContext.jsx";

export default function ForgotPassword() {
  const { requestPasswordReset, error } = useAuth();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    const res = await requestPasswordReset(email);
    setSubmitting(false);
    if (res) setSent(true);
  }

  return (
    <div className="page" style={{ maxWidth: 400, paddingTop: "18vh" }}>
      <div className="kicker" style={{ marginBottom: 28 }}>
        <span className="the-line" />
        CONQUEST
      </div>
      <h1 style={{ marginBottom: 16 }}>Reset your password</h1>
      {sent ? (
        <p style={{ color: "var(--muted)" }}>
          If an account exists for that email, a reset link has been sent. Follow it to set a new
          password.
        </p>
      ) : (
        <>
          <p style={{ color: "var(--muted)", marginBottom: 28 }}>
            Enter the email on your account and we will send you a link to set a new password.
          </p>
          <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
            {error && <div style={{ color: "var(--error)", fontSize: 13.5 }}>{error}</div>}
            <button className="btn-primary" type="submit" disabled={submitting} style={{ marginTop: 8 }}>
              {submitting ? "Sending…" : "Send reset link"}
            </button>
          </form>
        </>
      )}
      <div style={{ marginTop: 20, fontSize: 13.5 }}>
        <Link href="/login">Back to sign in</Link>
      </div>
    </div>
  );
}
